import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { container, small, segment, topLeft, topRight, bottomRight, bottomLeft } from "./PieChart.styles.css.mjs";
const PieChart = ({ value, size }) => /* @__PURE__ */ jsxs(
  Box,
  {
    padding: size === "small" ? "xxsmall" : "gutter",
    className: `${container} ${size === "small" ? small : ""}`,
    children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${segment} ${topLeft}`,
          style: {
            backgroundColor: value >= 1 ? "rgba(220, 50, 100, 1)" : "",
            opacity: value >= 1 ? 1 : 0
          }
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${segment} ${topRight}`,
          style: {
            backgroundColor: value > 25 ? "rgba(220, 50, 100, 1)" : "",
            opacity: value > 25 ? 1 : 0
          }
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${segment} ${bottomRight}`,
          style: {
            backgroundColor: value > 50 ? "rgba(220, 50, 100, 1)" : "",
            opacity: value > 50 ? 1 : 0
          }
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${segment} ${bottomLeft}`,
          style: {
            backgroundColor: value > 75 ? "rgba(220, 50, 100, 1)" : "",
            opacity: value > 75 ? 1 : 0
          }
        }
      )
    ]
  }
);
export {
  PieChart
};
